"use client";
import { Box, Flex, Spinner } from "@chakra-ui/react";
import type { PlaceResultProps } from "./current-location";
import { SearchOptionWrapper } from "./wrapper";

export const LoadingSearchOption = ({ label, ...rest }: PlaceResultProps) => {
  return (
    <SearchOptionWrapper
      color="gray.500"
      _hover={{
        bg: "blue.500",
        color: "white",
      }}
      cursor="pointer"
      role="option"
      aria-disabled={true}
      _loading={{
        cursor: "progress",
      }}
      _disabled={{
        color: "gray.200",
      }}
      {...rest}
    >
      <Flex ml="2" alignItems="center">
        <Spinner h="6" mr="3" />
        <Box fontWeight="semibold">{label}</Box>
      </Flex>
    </SearchOptionWrapper>
  );
};

export default LoadingSearchOption;
